import styled from "styled-components";
import badgePlaceholder from "assets/badge-placeholder.png";

const Image = styled.img`
  width: 64px;
  height: 64px;
  flex-shrink: 0;
`;

export const BadgePlaceholder = () => (
  <Image src={badgePlaceholder} alt="Badge placeholder" />
);
